import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../state-management/rootReducer';

const initialState: Application[] = [];

export const applicationSlice = createSlice({
  name: 'applications',
  initialState: initialState,
  reducers: {
    setApplications: (
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      state: Application[] = [],
      action: PayloadAction<Application[]>
    ) => {
      return [...action.payload];
    },
  },
});

export const { setApplications } = applicationSlice.actions;

export const getApplications = (state: RootState) => state.applications;

export default applicationSlice.reducer;
